import axiosAuth from "../../axiosAuth";
import * as actionTypes from "../../store/actions/types";
import { viewAccessRequest } from "../../store/actions/authActions";
import { resetOnboarding } from "../../store/onboardingV2/actions.ts";
import { fireAnalytics } from "../firebase.js";
import { getSessionId, getDeviceCategory } from "../analyticsHelpers.ts";
import { buildOAuthTokenBody } from "../session/sessionOAuth.ts";
import { applyAccessTokenToSession } from "../session/applyAccessTokenToSession.ts";
import { extractAccessTokenFromOAuthBody } from "../session/oauthApiResponse.ts";

const OAUTH_BASIC_CONFIG = {
  headers: { Authorization: "Basic ZWRpZnk6bGFjbGF2ZXNlY3JldGExMjM0" },
};

async function requestOAuthTokens(
  email: string,
  password: string
) {
  const response = await axiosAuth.post(
    "/oauth/token",
    buildOAuthTokenBody(email, password),
    OAUTH_BASIC_CONFIG
  );
  const access_token = extractAccessTokenFromOAuthBody(response.data);
  if (!access_token) {
    throw new Error("OAuth token response missing access_token");
  }
  return { access_token };
}

function dispatchLoggedInWithTokens(
  dispatch: (action: any) => void,
  access_token: string
) {
  applyAccessTokenToSession(dispatch, access_token);
  dispatch({ type: actionTypes.LOGIN_SUCCESS });
}

async function fetchUserProfileAndDispatchGetData(
  dispatch: (action: any) => void,
  access_token: string
) {
  const userDataResponse = await axiosAuth.get("/user/data", {
    headers: { Authorization: `Bearer ${access_token}` },
  });
  const userData = userDataResponse.data;
  dispatch(viewAccessRequest());
  fireAnalytics("login_success", {
    category: "authentication",
    edify_user_id: userData.id,
    session_id: getSessionId(),
    device_category: getDeviceCategory(),
    login_method: "automatic",
    user_type: userData.type || "",
    action: "login_success",
  });
  dispatch({ type: actionTypes.GET_DATA, payload: userData });
  return userData;
}

export async function establishSessionAfterMigracionBolsa(
  email: string,
  password: string,
  dispatch: (action: any) => void
) {
  const { access_token } = await requestOAuthTokens(email, password);
  dispatchLoggedInWithTokens(dispatch, access_token);
  dispatch(resetOnboarding());
  localStorage.removeItem("persist:onboardingV2");
  return fetchUserProfileAndDispatchGetData(dispatch, access_token);
}

export async function establishSessionAfterAltaNuevaBolsa(
  email: string,
  password: string,
  dispatch: (action: any) => void
) {
  const { access_token } = await requestOAuthTokens(email, password);
  dispatchLoggedInWithTokens(dispatch, access_token);
  return fetchUserProfileAndDispatchGetData(dispatch, access_token);
}
